import { fromJS } from 'immutable';
import * as actions from './actionTypes';
import { getErrorCode, getErrorMessage } from '../../containers/Error';
import { deleteCookie } from '../../utils/common/cookies';

export const stateKey = 'AuthenticationStore';

const initialState = fromJS({
  loading: false,
  data: {
    isLoggedIn: null,
    timeLeft: 0,
    sonnetAddressBookUid: null,
    email: null,
    preferredLang: null,
    userId: 0,
  },
  error: { error: false, code: null, message: null, type: null, state: 'authentication' },
});

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.VALIDATE_LOGGEDIN:
      return state
        .set('loading', true);

    case actions.VALIDATE_LOGGEDIN_FAILED:
      return state
        .set('loading', false)
        .setIn(['error', 'error'], true)
        .setIn(['error', 'code'], getErrorCode(action.payload.error))
        .setIn(['error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['error', 'type'], action.type)
        .setIn(['data', 'isLoggedIn'], false);

    case actions.CLEAR_VALIDATE_LOGGEDIN_ERROR:
      deleteCookie('claim_support_id', true);
      return state
        .set('loading', false)
        .setIn(['error', 'error'], false);

    case actions.VALIDATE_LOGGEDIN_SUCCESS:
      return state
        .set('loading', false)
        .setIn(['data', 'isLoggedIn'], action.payload.isLoggedIn)
        .setIn(['data', 'timeLeft'], action.payload.timeLeft)
        .setIn(['data', 'sonnetAddressBookUid'], action.payload.sonnetAddressBookUid)
        .setIn(['data', 'email'], action.payload.email)
        .setIn(['data', 'preferredLang'], action.payload.preferredLang)
        .setIn(['data', 'userId'], action.payload.userId);

    case actions.LOGOUT:
      return state
        .set('loading', true);

    case actions.LOGOUT_SUCCESS:
      deleteCookie('claim_support_id', true);
      return state
        .set('loading', false)
        .setIn(['data', 'isLoggedIn'], false);

    case actions.LOGOUT_FAILED:
      return state
        .set('loading', false);

    case actions.CHANGE_LANGUAGE:
      return state.setIn(['data', 'preferredLang'], action.payload.preferredLang);

    default:
      return state;
  }
};

export default authenticationReducer;
